export class SelectItemModel {
  display: string;
  value: string;
  searchTerms: string[];
}
